import {
    ExportOutlined,
    FileDoneOutlined,
    MessageOutlined,
    PictureOutlined,
} from '@ant-design/icons';
import { Button } from 'antd';
import { observer } from 'mobx-react';
import React from 'react';
import styled from 'styled-components';

import store from 'stores/RootStore';
import { AnimationPanelViews } from 'types/AnimationPanelViews';

const Container = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: left;
    margin-left: 5px;
    gap: 5px;
`;

function NavButtons() {
    const store_animation = store.animation;

    const newCommentsCount =
        store_animation && store_animation.newCommentsCount > 0
            ? ` (${store_animation.newCommentsCount})`
            : '';

    const handleOpenComments = () => {
        if (store_animation) {
            if (store_animation.displayPanel !== AnimationPanelViews.COMMENTS) {
                window.setTimeout(() => {
                    store_animation.comments.updateViewHistory();
                }, 1000);
            }
            store_animation.setPanelOrToggle(AnimationPanelViews.COMMENTS);
        }
    };

    return (
        <Container>
            <Button
                icon={<FileDoneOutlined />}
                disabled={!store_animation}
                onClick={() =>
                    store_animation?.setPanelOrToggle(
                        AnimationPanelViews.VERSIONS
                    )
                }
            >
                Versions
            </Button>

            <Button
                icon={<ExportOutlined />}
                disabled={!store_animation}
                onClick={() =>
                    store_animation?.setPanelOrToggle(
                        AnimationPanelViews.EXPORT
                    )
                }
            >
                Export
            </Button>

            <Button
                icon={<PictureOutlined />}
                disabled={!store_animation}
                onClick={() =>
                    store_animation?.setPanelOrToggle(
                        AnimationPanelViews.CANVAS
                    )
                }
            >
                Canvas
            </Button>

            <Button
                icon={<MessageOutlined />}
                type={newCommentsCount ? 'primary' : 'default'}
                onClick={handleOpenComments}
            >
                Comments {newCommentsCount}
            </Button>
        </Container>
    );
}

export default observer(NavButtons);
